import React from 'react'
import {Link} from 'react-router'
import root from '../shared/utils'

export default React.createClass({

  logout: function() {
      sessionStorage.clear();
      document.cookie = "addressId=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      document.cookie = "optOutOfBeta=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

  },
  render: function(){
    let mediaServer = root + '/common/latest/images/'
    let Logo = mediaServer + 'TaskEasyLogo.svg'
    let logoutPath = root + '/logout'
    let headerListItems = [
      <a href={logoutPath} onClick={this.logout} style={{paddingRight: '22px', textDecoration: 'none'}} className='baseline-color'>Logout</a>,
    ]
    let headerNodes = headerListItems.map(function (node, i) {return (<li key={i}><p>{node}</p></li>)})
  return (
        <div className='application-header'>
          <Link to='/dashboard'>
            <img className='TaskEasy-Logo' src={Logo} alt='TaskEasy Logo' />
          </Link>
          <nav className='collapse navbar-collapse' id='header' style={{float: 'right'}}>
            <ul className='nav navbar-nav navbar-right pull-down-sm-2 hidden-xs'>
              {headerNodes}
            </ul>
          </nav>
        </div>
  )}
});



// WEBPACK FOOTER //
// ./src/components/shared/header.jsx